document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.aseave-effects');
  if (!section) return;

  const tabs = Array.from(section.querySelectorAll('.aseave-effects__tab'));
  const panels = Array.from(section.querySelectorAll('.aseave-effects__panel'));
  let isTransitioning = false;

  // 相乗効果テキストの一部をNoto Sans JPフォントに変更
  const synergyElements = section.querySelectorAll('.aseave-effects__synergy');
  synergyElements.forEach((element) => {
    let text = element.innerHTML;

    // 各タブで変更するテキストパターンを定義
    const patterns = [
      /(血管内皮・代謝・自律神経に多面的に関与。)/g,
      /(「抗菌バランス＋発酵代謝」サポートが見込まれ、腸全体のリズムに貢献。)/g,
      /(肌の内側からのエイジングケアを実現。)/g,
      /(「飲む設計」と組み合わせることで睡眠の質を高める土台を形成。)/g
    ];

    // すべてのパターンに対してspanで囲む
    patterns.forEach(pattern => {
      text = text.replace(pattern, '<span class="noto-sans">$1</span>');
    });

    element.innerHTML = text;
  });

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const targetId = tab.dataset.tabTarget;
      if (!targetId || isTransitioning) return;

      const currentPanel = section.querySelector('.aseave-effects__panel.is-active');
      const targetPanel = section.querySelector(`#${targetId}`);

      // 同じパネルがクリックされた場合は何もしない
      if (currentPanel === targetPanel) return;

      isTransitioning = true;

      // フェードアウト開始
      if (currentPanel) {
        currentPanel.classList.add('fade-out');

        // フェードアウト完了後にパネルを切り替え
        setTimeout(() => {
          // すべてのタブとパネルの状態をリセット
          tabs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach((panel) => {
            panel.classList.remove('is-active', 'fade-out');
          });

          // 新しいタブとパネルをアクティブに
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          if (targetPanel) {
            // まず display: block を適用（opacity: 0 のまま）
            targetPanel.style.display = 'block';
            targetPanel.style.opacity = '0';

            // 次のフレームで opacity: 1 を適用してフェードイン
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                targetPanel.classList.add('is-active');
                targetPanel.style.display = '';
                targetPanel.style.opacity = '';
              });
            });
          }

          setTimeout(() => {
            isTransitioning = false;
          }, 400);
        }, 400); // CSSのtransition時間と一致させる
      } else {
        // 初回の場合（currentPanelがない場合）
        tabs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach((panel) => {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }

        isTransitioning = false;
      }
    });
  });
});
